import { useEffect } from "react";
const useSendTelemetryOnMount = (sendTelemetry, eventType, event, deps = []) => {
  useEffect(() => {
    sendTelemetry(eventType, event);
  }, [sendTelemetry, ...deps]);
};
export default useSendTelemetryOnMount;
